"use client"
export const SERVICE_PROFILE_ACTION_OPTIONS = [
  { value: "BUY", label: "Shop" },
  { value: "SELL", label: "Sell" },
  { value: "RENT", label: "Rent" },
  { value: "BORROW", label: "Borrow" },
  { value: "DONATE", label: "Donate" },
  { value: "RECYCLE", label: "Recycle" },
  { value: "DISPOSE", label: "Dispose" },
  { value: "REPAIR", label: "Repair" },
  { value: "COMPOST", label: "Compost" }
];

export const SERVICE_PROFILE_CONDITION_OPTIONS = [
  { value: "NEW", label: "New" },
  { value: "USED", label: "Used - Reusable" },
  { value: "USED_NON_REUSABLE", label: "Used - Non-Reusable" }
];
